import React from 'react';
import styles from './SelectType.module.css';

// Делали TItem дженериком, чтобы id был литеральным типом
export type TItem<T extends string> = { id: T; name: string };

interface SelectorProps<T extends string> {
  title: string;
  items: TItem<T>[];
  value: T;
  onChange: (v: T) => void;
  error?: boolean;
}

export const Selector = <T extends string>({
  title,
  items,
  value,
  onChange,
  error = false,
}: SelectorProps<T>) => {
  return (
    <div className={styles.selector}>
      <label className={styles.label}>{title}</label>
      <select
        className={error ? styles.selectError : styles.select}
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
      >
        {items.map((it) => (
          <option key={it.id} value={it.id}>
            {it.name}
          </option>
        ))}
      </select>
    </div>
  );
};
